import { LOANREQUEST_BUCKETS, ORGANIZATIONS, USER_ROLES } from 'cpool-constants';
import { z } from 'zod';

import { schemaUserCommon } from './userCommon';
import { divisionId } from '../../Division/Division';
import { schemaId } from '../../utils/schema.utils';

export const schemaDivisionLeader = z
    .object({
        assignable: z.boolean().default(false),
        buckets: z.array(z.nativeEnum(LOANREQUEST_BUCKETS)).optional(),
        // deprecated: legacy assignment field, group membership lives on the group aggregates
        corporationId: schemaId.optional(),
        divisionId: divisionId.optional(),
        organization: z.nativeEnum(ORGANIZATIONS),
        ownedBuckets: z.array(z.nativeEnum(LOANREQUEST_BUCKETS)).optional(),
        role: z.literal(USER_ROLES.division_leader),
    })
    .merge(schemaUserCommon);
